import React, { useEffect } from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import './Technology.css';

const Technology: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="technology-page">
      <section className="tech-hero">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="pulse"></span>
            {t.tech.badge}
          </div>
          <h1 className="hero-title">
            <span className="gradient-text">{t.tech.hero_title1}</span>{' '}
            <span>{t.tech.hero_title2}</span>
          </h1>
          <p className="hero-subtitle">{t.tech.hero_subtitle}</p>
        </div>
      </section>

      <div className="tech-content">
        <div className="section-block">
          <div className="section-label">{t.tech.overview_label}</div>
          <h2>
            <span>{t.tech.overview_title1}</span>{' '}
            <span className="gradient-text">{t.tech.overview_title2}</span>
          </h2>
          <p>{t.tech.overview_desc1}</p>
          <p>{t.tech.overview_desc2}</p>
        </div>

        <div className="note">
          <strong>{t.tech.note_label}</strong>
          <span>{t.tech.note_desc}</span>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.tech.domain1_label}</div>
          <h2>
            <span>{t.tech.domain1_title1}</span>{' '}
            <span className="gradient-text">{t.tech.domain1_title2}</span>{' '}
            <span>{t.tech.domain1_title3}</span>
          </h2>
        </div>

        <div className="tech-card-grid">
          <div className="tech-card">
            <h3>{t.tech.consensus_title}</h3>
            <p>{t.tech.consensus_desc1}</p>
            <p>{t.tech.consensus_desc2}</p>
          </div>
          <div className="tech-card">
            <h3>{t.tech.incentive_title}</h3>
            <p>{t.tech.incentive_desc}</p>
          </div>
          <div className="tech-card">
            <h3>{t.tech.app_title}</h3>
            <p>{t.tech.app_desc}</p>
          </div>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.tech.domain2_label}</div>
          <h2>
            <span>{t.tech.domain2_title1}</span>{' '}
            <span className="gradient-text">{t.tech.domain2_title2}</span>{' '}
            <span>{t.tech.domain2_title3}</span>
          </h2>
        </div>

        <div className="tech-card-grid">
          <div className="tech-card">
            <h3>{t.tech.base_eco}</h3>
            <p>{t.tech.base_desc1}</p>
            <p>{t.tech.base_desc2}</p>
          </div>
          <div className="tech-card">
            <h3>{t.tech.agg_eco}</h3>
            <p>{t.tech.agg_desc1}</p>
            <p>{t.tech.agg_desc2}</p>
          </div>
          <div className="tech-card">
            <h3>{t.tech.fin_eco}</h3>
            <p>{t.tech.fin_desc1}</p>
            <p>{t.tech.fin_desc2}</p>
          </div>
          <div className="tech-card">
            <h3>{t.tech.ent_eco}</h3>
            <p>{t.tech.ent_desc1}</p>
            <p>{t.tech.ent_desc2}</p>
          </div>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.tech.gateway_label}</div>
          <h2>
            <span>{t.tech.gateway_title1}</span>
            <span className="gradient-text">{t.tech.gateway_title2}</span>
          </h2>
          <p>{t.tech.gateway_desc}</p>
        </div>

        <div className="divider"></div>

        <div className="section-block">
          <div className="section-label">{t.tech.positioning_label}</div>
          <h2>
            <span>{t.tech.positioning_title1}</span>{' '}
            <span className="gradient-text">{t.tech.positioning_title2}</span>
          </h2>
          <p>{t.tech.positioning_desc}</p>
        </div>

        <div className="closing">
          <p className="mission-label">{t.tech.mission_label}</p>
          <p>{t.tech.mission_desc}</p>
        </div>
      </div>
    </div>
  );
};

export default Technology;
